/** @jsxImportSource @emotion/react */

import React, { ReactNode } from 'react';
import { ProgressState } from '../App';
import { Progress } from '../Data/index';
import { AnimatedDelightLeft } from './delight-left';
import { AnimatedDelightRight } from './delight-right';
import { AnimatedConfettiLeft } from './confetti-left';
import { AnimatedConfettiRight } from './confetti-right';

type MainProps = {
  children: ReactNode;
  progress: ProgressState;
};


export const Main = ({ progress, ...props }: MainProps) => {
  const timeForConfetti = progress.status === Progress.Complete;
  const decoration_left = timeForConfetti ? <AnimatedConfettiLeft /> : <AnimatedDelightLeft />
  const decoration_right = timeForConfetti ? <AnimatedConfettiRight /> : <AnimatedDelightRight />;

  return (
    <main
      css={{
        position: 'relative',
        margin: '0 auto',
        maxWidth: '1920px',
      }}
    >
      {decoration_left}
      {/* ************* */}
      <section
        css={{
          margin: '0 auto',
          maxWidth: '1014px',
          padding: '0 0.75rem'
        }}
        {...props}
      />
      {/* ************* */}
      {decoration_right}
    </main>
  );
};

Main.displayName = 'Main';
